import React, { useEffect, useState } from "react";
import {
  appDownloadLinks,
  footerLinks,
  navigationLinks,
  socialLinks,
} from "../../utils/footer.helpers";
import { Link } from "react-router-dom";
import "../../../styles/footer.css"

const Footer = () => {
  // const currentYear = new Date().getFullYear();
  // const [redirectLink, setRedirectLinki] = useState("Windows");
  // useEffect(() => {
  //   const os = navigator.userAgent;
  //   var windowsLink = "https://anydone.com/download-page-windows.html";
  //   var macLink = "https://anydone.com/download-page-mac.html";
  //   var linuxLink = "https://anydone.com/download-page-linux.html";

  //   let finalOs = "";
  //   if (os.search("Windows") !== -1) {
  //     setRedirectLinki(windowsLink);
  //   } else if (os.search("Mac") !== -1) {
  //     setRedirectLinki(macLink);
  //   } else if (os.search("X11") !== -1 && !(os.search("Linux") !== -1)) {
  //     setRedirectLinki(linuxLink);
  //   } else if (os.search("Linux") !== -1 && os.search("X11") !== -1) {
  //     setRedirectLinki(linuxLink);
  //   } else {
  //     setRedirectLinki(windowsLink);
  //   }
  // }, []);

  return (
    <div className="footer-container">
      <footer className="footer">
        {/* Footer top */}
        <div className="footer-top">
          {navigationLinks.map((category, index) => (
            <div className="footer-category" key={index}>
              <h4 className="footer-category h4">{category.category}</h4>
              <div className="footer-category-links">
                {category.items.map((item, subIndex) => (
                  <Link key={subIndex} to={item.url}>
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <hr className="footer-divider" />
        {/* Footer bottom */}
        <div className="footer-bottom">
          {/* Social Links */}
          <div className="social-links">
            {socialLinks.map((social, index) => (
              <Link
                to={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                key={index}
              >
                <img
                  src={`${social.icon}`}
                  alt={social.name}
                  className={
                    social.isTarget ? "social-icon" : "social-icon hover"
                  }
                />
              </Link>
            ))}
          </div>
          {/* Footer Links */}
          <div className="footer-links">
            {footerLinks.map((item, index) =>
              item.type === "text" ? (
                <p key={index}>{item.content}</p>
              ) : (
                <Link
                  to={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={index}
                >
                  {item.label}
                </Link>
              )
            )}
          </div>
          {/* App Download Links */}
          <div className="app-download-links">
            {appDownloadLinks.map((app, index) => (
              <Link
                to={app.url}
                target="_blank"
                aria-label={app.name}
                key={index}
              >
                <img src={app.icon} alt="" className="app-icon" />
              </Link>
            ))}
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Footer;
